import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	ArcElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { months } from '../TableOptions';



ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	ArcElement,
	Title,
	Tooltip,
	Legend
);




const BarChart = ({ threeinone, applicant, screening, evaluation, interview, interviewHistory, offered, hired, dropout }: any) => {



	const data = {
		labels: ["Applicant", "Screening", "Evaluation", "Interview", "Interview History", "Offered", "Hired", "Drop out"],
		datasets: [


			{
				label: 'New',
				backgroundColor: '#005b90',
				borderColor: '#E5ECFB',
				borderWidth: 1,
				barThickness: 20,
				data: [applicant, screening, evaluation, interview, interviewHistory, offered, hired, !dropout ? 0 : dropout],
			},
		],
	};

	const options = {
		plugins: {
			legend: {
				display: false,
			},
		},
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
			},
		},
		responsive: true,
		maintainAspectRatio: false,
		height: 600,
	};

	return (
		<div className={threeinone}>
			<Bar data={data} options={options} height={"100%"} width={"100%"} />
		</div>
	);
}

export default BarChart;
